import { render, staticRenderFns } from "./ClientLogo.vue?vue&type=template&id=7ccf90c9&scoped=true"
import script from "./ClientLogo.vue?vue&type=script&lang=js"
export * from "./ClientLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf90c9",
  null
  
)

export default component.exports